/* eslint-disable array-bracket-newline */
/**
 *  Pool Widget calculations helper
 */
import { IGoPlusTokenData } from '../../../helpers/goPlusApi';

// counts GoPlus Security issues
const countIssues = (data: IGoPlusTokenData | null): number => {
  if (!data) {
    return 0;
  }

  let issues = 0;

  const negativeFields: Array<keyof IGoPlusTokenData> = [
    'selfdestruct',
    'transfer_pausable',
    'anti_whale_modifiable',
    'can_take_back_ownership',
    'hidden_owner',
    'is_anti_whale',
    'is_blacklisted',
    'is_honeypot',
    'is_proxy',
    'cannot_buy',
    'cannot_sell_all',
    'is_airdrop_scam',
    'honeypot_with_same_creator',
  ];

  const positiveFields: Array<keyof IGoPlusTokenData> = [
    'is_open_source',
    'is_whitelisted',
  ];

  const toBoolean = (value: any): boolean => value === '1';

  negativeFields.forEach((field) => {
    if (data[field] && toBoolean(data[field])) {
      issues += 1;
    }
  });

  positiveFields.forEach((field) => {
    if (data[field] && !toBoolean(data[field])) {
      issues += 1;
    }
  });

  return issues;
};

export { countIssues };
